var _path, _rect, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1132 0.342773C9.0849 0.342773 5.49056 0.352207 2.46226 0.352207H2.42453C0.999999 0.352207 0 1.44655 0 3.05975C0 7.03145 0 10.9937 0 14.9654C0 18.9371 0 20.0692 0 24.0409C0 25.6541 0.999999 26.7484 2.42453 26.7484H17.5377C19.0188 26.7484 20 25.6729 20 24.022V9.33333C17.6792 9.33333 12.1038 2.98428 12.1038 0.342773H12.1132Z",
    fill: "url(#paint0_linear_5580_23072)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.83447,
    y: 13.9716,
    width: 12.3298,
    height: 6.60825,
    rx: 2,
    fill: "#1A2037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1128 0.342773V7.75786C12.1128 8.8522 12.5468 9.34276 13.5279 9.34276H19.9996C19.9996 9.34276 19.9996 9.37106 19.9996 9.34276L12.1128 0.342773Z",
    fill: "url(#paint1_linear_5580_23072)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5580_23072",
    x1: -1.11321,
    y1: 45.7201,
    x2: 13.8679,
    y2: 2.37107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5580_23072",
    x1: 26.8171,
    y1: -5.24309,
    x2: 5.58087,
    y2: 16.4325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9e36e08702519a7ab240c826755d29a.svg";
export { ForwardRef as ReactComponent };